import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AccountingDashboardData, AccountingDateRange } from '../models/accounting-dashboard.model';

@Injectable({ providedIn: 'root' })
export class AccountingDashboardService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/dashboard/accounting`;

  async getDashboard(range: AccountingDateRange): Promise<AccountingDashboardData> {
    const params = new HttpParams()
      .set('dateFrom', range.dateFrom)
      .set('dateTo', range.dateTo);
    const response = await firstValueFrom(
      this.http.get<{ dashboard: AccountingDashboardData }>(this.apiUrl, {
        params,
        withCredentials: true,
      }),
    );
    return response.dashboard;
  }
}
